// extracted by mini-css-extract-plugin
export default {"quantity_container":"tG","hiddenflavorstring":"uG","loadingLine":"vG","productimgwrap":"wG","productimg":"xG","circlepic":"yG","productinfo":"zG","grey_x":"AG","cartrow":"BG","bold":"CG","title":"EG","blue":"FG","strike":"GG","flexgap":"HG","flavorstring":"IG","nodecorate":"JG","flavorstring_link":"KG","rdstring":"LG","removeditemblock":"MG","removed_heading":"NG","removed_text":"OG","addback":"PG"};
    if(module.hot) {
      // 1714654893479
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  